import { LOGIN as type } from "../actions/types";
import { adminServerInstance } from '../axios/instances.js';
import { setUserPreference } from "../utilities/common";

const initialState = {
	loading: false,
	error: false,
	isLoggedIn: false,
};

export default function userReducer(state = initialState, action) {
	switch (action.type) {
		case type.USER_LOGIN:
			return {
				...state,
				loading: true,
				error: false,
			};
		case type.USER_LOGIN_SUCCESS:
			let data = action.payload;

			setUserPreference(data.token, data.level, data.city_id, data.username, data.id);
			adminServerInstance.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;

			return {
				...state,
				loading: false,
				isLoggedIn: true,
			};
		case type.USER_LOGIN_FAIL:
			return {
				...state,
				loading: false,
				error: action.error,
			};
		case type.USER_LOGOUT:
			// Unused currently
			setUserPreference(null, null, null, null, null);

			return initialState;
		default:
			return state;
	}
}